import { render, staticRenderFns } from "./EmploymentDocuments.vue?vue&type=template&id=f07bb40c&"
import script from "./EmploymentDocuments.vue?vue&type=script&lang=ts&"
export * from "./EmploymentDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports